const GRAVADO = '10'
const EXONERADO = '20'
const INAFECTO = '30'
const INAFECTO_RETIROPORBONIFICACION = '31'
const EXPORTACION = '40'

const __dictionary = {
  [GRAVADO]: {
    id: GRAVADO,
    nombre: '10 - GRAVADO'
  },
  [EXONERADO]: {
    id: EXONERADO,
    nombre: '20 - EXONERADO'
  },
  [INAFECTO]: {
    id: INAFECTO,
    nombre: '30 - INAFECTO'
  },
  [INAFECTO_RETIROPORBONIFICACION]: {
    id: INAFECTO_RETIROPORBONIFICACION,
    nombre: '31 - INAFECTO - RETIRO POR BONIFICACION'
  },
  [EXPORTACION]: {
    id: EXPORTACION,
    nombre: '40 - EXPORTACION'
  }
}

const __array = [
  __dictionary[GRAVADO],
  __dictionary[EXONERADO],
  __dictionary[INAFECTO],
  __dictionary[INAFECTO_RETIROPORBONIFICACION],
  __dictionary[EXPORTACION]
]

const __arrayVentasContabilidad = [
  __dictionary[GRAVADO],
  __dictionary[EXONERADO],
  __dictionary[INAFECTO],
  __dictionary[EXPORTACION]
]

export default Object.freeze({
  GRAVADO,
  EXONERADO,
  INAFECTO,
  INAFECTO_RETIROPORBONIFICACION,
  EXPORTACION,
  __dictionary,
  __array,
  __arrayVentasContabilidad
})
